export const SMARTY_US_AUTOCOMPLETE_KEY = '22361352819063501';
export const SMARTY_INTL_AUTOCOMPLETE_KEY = '22361352819063501';
export const SMARTY_INTL_STREET_KEY = '22361352819063501';
export const SMARTY_US_STREET_KEY = '22361352819063501';

